// Complete list of all supported languages with ISO 639-1 codes
export interface Language {
  code: string
  name: string
  flag: string
}

export const ALL_LANGUAGES: Language[] = [
  // Common languages first
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'French', flag: '🇫🇷' },
  { code: 'de', name: 'German', flag: '🇩🇪' },
  { code: 'es', name: 'Spanish', flag: '🇪🇸' },
  { code: 'it', name: 'Italian', flag: '🇮🇹' },
  { code: 'pt-PT', name: 'Portuguese (Portugal)', flag: '🇵🇹' },
  { code: 'pt-BR', name: 'Portuguese (Brazil)', flag: '🇧🇷' },
  { code: 'zh', name: 'Chinese (Simplified)', flag: '🇨🇳' },
  { code: 'zh-TW', name: 'Chinese (Traditional)', flag: '🇹🇼' },
  { code: 'ja', name: 'Japanese', flag: '🇯🇵' },
  { code: 'ko', name: 'Korean', flag: '🇰🇷' },
  // Other languages (alphabetical)
  { code: 'af', name: 'Afrikaans', flag: '🇿🇦' },
  { code: 'sq', name: 'Albanian', flag: '🇦🇱' },
  { code: 'am', name: 'Amharic', flag: '🇪🇹' },
  { code: 'ar', name: 'Arabic', flag: '🇸🇦' },
  { code: 'ay', name: 'Aymara', flag: '🇧🇴' },
  { code: 'az', name: 'Azerbaijani', flag: '🇦🇿' },
  { code: 'bn', name: 'Bengali', flag: '🇧🇩' },
  { code: 'bs', name: 'Bosnian', flag: '🇧🇦' },
  { code: 'bg', name: 'Bulgarian', flag: '🇧🇬' },
  { code: 'my', name: 'Burmese', flag: '🇲🇲' },
  { code: 'ca', name: 'Catalan', flag: '🇪🇸' },
  { code: 'hr', name: 'Croatian', flag: '🇭🇷' },
  { code: 'cs', name: 'Czech', flag: '🇨🇿' },
  { code: 'da', name: 'Danish', flag: '🇩🇰' },
  { code: 'nl', name: 'Dutch', flag: '🇳🇱' },
  { code: 'et', name: 'Estonian', flag: '🇪🇪' },
  { code: 'fi', name: 'Finnish', flag: '🇫🇮' },
  { code: 'ka', name: 'Georgian', flag: '🇬🇪' },
  { code: 'el', name: 'Greek', flag: '🇬🇷' },
  { code: 'gn', name: 'Guarani', flag: '🇵🇾' },
  { code: 'gu', name: 'Gujarati', flag: '🇮🇳' },
  { code: 'ha', name: 'Hausa', flag: '🇳🇬' },
  { code: 'he', name: 'Hebrew', flag: '🇮🇱' },
  { code: 'hi', name: 'Hindi', flag: '🇮🇳' },
  { code: 'hu', name: 'Hungarian', flag: '🇭🇺' },
  { code: 'is', name: 'Icelandic', flag: '🇮🇸' },
  { code: 'ig', name: 'Igbo', flag: '🇳🇬' },
  { code: 'id', name: 'Indonesian', flag: '🇮🇩' },
  { code: 'ga', name: 'Irish', flag: '🇮🇪' },
  { code: 'jv', name: 'Javanese', flag: '🇮🇩' },
  { code: 'kn', name: 'Kannada', flag: '🇮🇳' },
  { code: 'kk', name: 'Kazakh', flag: '🇰🇿' },
  { code: 'km', name: 'Khmer', flag: '🇰🇭' },
  { code: 'ku', name: 'Kurdish', flag: '🏳️' },
  { code: 'lo', name: 'Lao', flag: '🇱🇦' },
  { code: 'lv', name: 'Latvian', flag: '🇱🇻' },
  { code: 'lt', name: 'Lithuanian', flag: '🇱🇹' },
  { code: 'mk', name: 'Macedonian', flag: '🇲🇰' },
  { code: 'ms', name: 'Malay', flag: '🇲🇾' },
  { code: 'ml', name: 'Malayalam', flag: '🇮🇳' },
  { code: 'mt', name: 'Maltese', flag: '🇲🇹' },
  { code: 'mr', name: 'Marathi', flag: '🇮🇳' },
  { code: 'mn', name: 'Mongolian', flag: '🇲🇳' },
  { code: 'ne', name: 'Nepali', flag: '🇳🇵' },
  { code: 'nb', name: 'Norwegian Bokmål', flag: '🇳🇴' },
  { code: 'nn', name: 'Norwegian Nynorsk', flag: '🇳🇴' },
  { code: 'ps', name: 'Pashto', flag: '🇦🇫' },
  { code: 'fa', name: 'Persian', flag: '🇮🇷' },
  { code: 'pl', name: 'Polish', flag: '🇵🇱' },
  { code: 'pa', name: 'Punjabi', flag: '🇮🇳' },
  { code: 'qu', name: 'Quechua', flag: '🇵🇪' },
  { code: 'ro', name: 'Romanian', flag: '🇷🇴' },
  { code: 'ru', name: 'Russian', flag: '🏳️' },
  { code: 'sr', name: 'Serbian', flag: '🇷🇸' },
  { code: 'si', name: 'Sinhala', flag: '🇱🇰' },
  { code: 'sk', name: 'Slovak', flag: '🇸🇰' },
  { code: 'sl', name: 'Slovenian', flag: '🇸🇮' },
  { code: 'so', name: 'Somali', flag: '🇸🇴' },
  { code: 'su', name: 'Sundanese', flag: '🇮🇩' },
  { code: 'sw', name: 'Swahili', flag: '🇰🇪' },
  { code: 'sv', name: 'Swedish', flag: '🇸🇪' },
  { code: 'tl', name: 'Tagalog', flag: '🇵🇭' },
  { code: 'ta', name: 'Tamil', flag: '🇮🇳' },
  { code: 'te', name: 'Telugu', flag: '🇮🇳' },
  { code: 'th', name: 'Thai', flag: '🇹🇭' },
  { code: 'tr', name: 'Turkish', flag: '🇹🇷' },
  { code: 'uk', name: 'Ukrainian', flag: '🇺🇦' },
  { code: 'ur', name: 'Urdu', flag: '🇵🇰' },
  { code: 'uz', name: 'Uzbek', flag: '🇺🇿' },
  { code: 'vi', name: 'Vietnamese', flag: '🇻🇳' },
  { code: 'cy', name: 'Welsh', flag: '🏴󠁧󠁢󠁷󠁬󠁳󠁿' },
  { code: 'yo', name: 'Yoruba', flag: '🇳🇬' },
  { code: 'zu', name: 'Zulu', flag: '🇿🇦' },
] as const

// Default top languages (fallback when server data is not available)
export const DEFAULT_TOP_LANGUAGE_CODES = ['en', 'fr', 'de', 'es', 'nb', 'it', 'pt-PT', 'uk', 'zh', 'ja', 'ko']

// Helper to get language by code
export function getLanguageByCode(code: string) {
  return ALL_LANGUAGES.find(lang => lang.code === code)
}

// Helper to get language name by code
export function getLanguageName(code: string): string {
  const language = getLanguageByCode(code);
  return language ? language.name : code.toUpperCase();
}

// Helper to get all language codes
export function getAllLanguageCodes(): string[] {
  return ALL_LANGUAGES.map(lang => lang.code)
}

// Helper to get language flag by code or name
export function getLanguageFlag(codeOrName: string): string {
  // First try to find by code
  const languageByCode = getLanguageByCode(codeOrName);
  if (languageByCode) {
    return languageByCode.flag;
  }
  
  // Then try to find by name (case-insensitive)
  const languageByName = ALL_LANGUAGES.find(
    lang => lang.name.toLowerCase() === codeOrName.toLowerCase()
  );
  if (languageByName) {
    return languageByName.flag;
  }
  
  // Fallback to generic flag
  return '🏳️';
}
